var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { encode as msgpackEncode } from "algo-msgpack-with-bigint";
import { makeAssetTransferTxnWithSuggestedParams, makePaymentTxnWithSuggestedParams, } from "algosdk";
import { extractTokenId } from "./tokens";
export const buildTransactionPayload = (algorandAPI) => (account, transaction) => __awaiter(void 0, void 0, void 0, function* () {
    const { amount, recipient, mode, memo, assetId, subAccountId } = transaction;
    const subAccount = subAccountId
        ? account.subAccounts && account.subAccounts.find(t => t.id === subAccountId)
        : null;
    const note = memo ? new TextEncoder().encode(memo) : undefined;
    const params = yield algorandAPI.getTransactionParams();
    let algoTxn;
    if (subAccount || (assetId && mode === "optIn")) {
        const targetAssetId = subAccount && subAccount.type === "TokenAccount"
            ? extractTokenId(subAccount.token.id)
            : assetId
                ? extractTokenId(assetId)
                : "";
        if (!targetAssetId) {
            throw new Error("Token Asset Id not found");
        }
        algoTxn = makeAssetTransferTxnWithSuggestedParams(account.freshAddress, recipient, undefined, undefined, amount.toNumber(), note, Number(targetAssetId), params, undefined);
    }
    else {
        algoTxn = makePaymentTxnWithSuggestedParams(account.freshAddress, recipient, amount.toNumber(), undefined, note, params);
    }
    // Bit of safety: set tx validity to the next 1000 blocks
    algoTxn.firstRound = params.lastRound;
    algoTxn.lastRound = params.lastRound + 1000;
    // Flaw in the SDK: payload isn't sorted, but it needs to be for msgPack encoding
    const sorted = Object.fromEntries(Object.entries(algoTxn.get_obj_for_encoding()).sort());
    return sorted;
});
export const encodeToSign = (payload) => {
    const msgPackEncoded = msgpackEncode(payload);
    return Buffer.from(msgPackEncoded).toString("hex");
};
export const encodeToBroadcast = (payload, signature) => {
    const signedPayload = {
        sig: signature,
        txn: payload,
    };
    const msgPackEncoded = msgpackEncode(signedPayload);
    return Buffer.from(msgPackEncoded);
};
//# sourceMappingURL=buildTransaction.js.map